import styles from './NotFoundPage.module.css';
import { cn } from '@/lib/utils';
import { MoveLeft } from 'lucide-react';
import TextButton from '@/components/ui/shared/Button/TextButton/TextButton';
import { useNavigate } from 'react-router';

const NotFoundPage = () => {
	const navigate = useNavigate();
	return (
		<div
			className={cn(
				styles.wrapper,
				'bg-blue min-h-screen grid grid-cols-12 pt-8 pl-12 2xl:pt-10 2xl:pl-16'
			)}
		>
			<TextButton
				onClick={() => navigate('')}
				className="text-white font-bold w-44 bg-[#ffffff55]"
			>
				<MoveLeft /> Back to Home
			</TextButton>
		</div>
	);
};

export default NotFoundPage;
